import { differenceInDays, differenceInMinutes, format } from 'date-fns';
import { FormattingStrategy } from './formattingStrategy';

/**
 * 0-60 дней - только что
 * 60-190 дней - недавно
 * 190+ - дата
 */
export const days190strategy: FormattingStrategy = (lastActivityDate, now) => {
  const diffInMinutes = differenceInMinutes(now, lastActivityDate);
  const diffInDays = differenceInDays(now, lastActivityDate);

  if (diffInMinutes <= 15) {
    return 'в сети';
  }

  if (diffInDays < 60) {
    return 'только что';
  } else if (diffInDays <= 190) {
    return 'недавно';
  }

  return format(lastActivityDate, 'dd.MM.yy');
};
